import "../../style/fastShipment/FastShipmentPrice.css";
import { Modal, Button } from "@mui/material";
import { useCallback, useMemo } from "react";
import FastShipmentPrices from "./fastShipmentPriceModal/FastShipmentPrices";
import { useRecoilState } from "recoil";
import { fastListState } from "../../atoms/fastShipment";
import { shouldHideSupplier } from "../../utils/SpecialUserIds";

const FastShipmentPriceModal = ({
  status,
  setStatus,
  items,
  setSelectedPriceObject,
  setPriceID,
  setPriceIDValue,
  dataID,
  insuranceFast,
  setInsuranceFast,
  ddpFast,
  setDdpFast,
  lucidFast,
  setLucidFast,
  isAbove150EURCheck,
  setIsAbove150EURCheck,
  selectedFastShipmentProduct
}) => {
  // const sortedItems = [...item?.prices?.data]?.sort((a, b) => a?.selling_price - b?.selling_price);

  const [fastList, setFastList] = useRecoilState(fastListState);

  // Filter suppliers: if 1342 is cheaper than 1350, show only 1342; if 1350 is cheaper, show both
  // YETKİLİ (permission 1 veya 2): 342, 343, 350 görünür - 1342, 1343, 1350 gizli
  // YETKİSİZ: 1342, 1343, 1350 görünür - 342, 343, 350 gizli
  const filteredPrices = useMemo(() => {
    const pricesData = items?.prices?.data || [];
    let tempArray = [...pricesData];
    
    // Yetki bazlı filtreleme
    // tempArray = tempArray.filter((x) => !shouldHideSupplier(x?.supplier_id));
    
    // Filter for 1342 and 1350
    const supplier1342 = tempArray?.find((x) => x?.supplier_id === 1342);
    const supplier1350 = tempArray?.find((x) => x?.supplier_id === 1350);

    if (supplier1342 && supplier1350) {
      const price1342 = (supplier1342?.selling_price ?? 0) * (supplier1342?.exchange_rate ?? 1);
      const price1350 = (supplier1350?.selling_price ?? 0) * (supplier1350?.exchange_rate ?? 1);

      // If 1342 is cheaper, show only 1342; if 1350 is cheaper or equal, show both
      if (price1342 < price1350) {
        tempArray = tempArray.filter((x) => x?.supplier_id !== 1350);
      }
    }

    return tempArray;
  }, [items?.prices?.data]);

  const handleCloseReset = useCallback(() => {
    // Modal kapandığında (dışına tıklama veya Kapat) ilgili kaydın isPriceTake değerini "0" yap
    if (dataID) {
      setFastList((prevList) =>
        prevList.map((fast) =>
          fast.id === dataID
            ? {
                ...fast,
                isPriceTake: "0",
              }
            : fast
        )
      );
    }
    setStatus(false);
  }, [dataID, setFastList, setStatus]);

  const handleCloseNoReset = useCallback(() => {
    // Fiyat seçildiğinde sadece modal kapansın, isPriceTake korunur
    setStatus(false);
  }, [setStatus]);

  const member = JSON.parse(localStorage.getItem("user"));
  const memberId = member?.user?.user_member?.id;

  return (
    <Modal open={status} onClose={handleCloseReset} className="get-card-modal">
      <div
        className="get-card-container"
        style={{
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div className="get-card-wrapper">
          {filteredPrices?.map((item, key) => (
            <FastShipmentPrices
              key={key}
              item={item}
              items={items}
              setSelectedPriceObject={setSelectedPriceObject}
              handleClose={handleCloseNoReset}
              setPriceID={setPriceID}
              setPriceIDValue={setPriceIDValue}
              dataID={dataID}
              insuranceFast={insuranceFast}
              setInsuranceFast={setInsuranceFast}
              ddpFast={ddpFast}
              setDdpFast={setDdpFast}
              lucidFast={lucidFast}
              setLucidFast={setLucidFast}
              isAbove150EURCheck={isAbove150EURCheck}
              setIsAbove150EURCheck={setIsAbove150EURCheck}
              selectedFastShipmentProduct={selectedFastShipmentProduct}
            />
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <Button className="iyzi-button-blue" onClick={handleCloseReset}>
            Kapat
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FastShipmentPriceModal;
